import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';
import type { RiskRecognitionHighlight, SilenceReason } from './Types';

export class RiskRecognitionsRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getHighlights = (): Promise<RiskRecognitionHighlight> => {
    const requestData: IRequest = {
      endpoint: '/v1/risk-recognitions/highlights',
      method: HttpMethod.POST,
    };

    return this.requester.request(requestData).then((response) => response.data);
  };

  /**
   * Silence a detection's highlight. Fire-and-forget: the 201 body
   * (criticality_ceiling, expires_at, …) is intentionally ignored.
   */
  public createSilence = (detectionId: string, reason: SilenceReason): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `/v1/risk-recognitions/detections/${detectionId}/silences`,
      method: HttpMethod.POST,
      body: JSON.stringify({ reason }),
    };

    return this.requester.request(requestData).then(() => undefined);
  };
}

export default RiskRecognitionsRequester;
